export const REVIEW_RESOURCE_NAME = 'review';
export const REVIEW_FORM_NAME = 'review';
